// API配置

export type ApiVersion = "v1" | "v2";

// 按环境与版本返回 API baseURL：由各环境 `.env*` 中 `VITE_API_BASE_URL` 配置；未配置时走本地相对路径（配合 Vite 代理）
export const getApiBaseURL = (version: ApiVersion): string => {
  const path = version === "v1" ? "v1" : "v2";
  return `${import.meta.env.VITE_DNS_PREFETCH_API}api/${path}/`;
};

export const API_CONFIG = {
  baseURL: getApiBaseURL("v1"),
  assetBaseURL: import.meta.env.MODE === "production" ? "" : "/@",
  timeout: 10000,
  withCredentials: true,
};

// 响应状态码
export const HTTP_STATUS = {
  SUCCESS: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;

// 业务状态码
export const BUSINESS_CODE = {
  SUCCESS: 200,
  TOKEN_EXPIRED: 1002,
  PERMISSION_DENIED: 1003,
} as const;
